import { Component, inject } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LABELS } from '../../../../commons/constants/labels.constant';
import { TvLoginStore } from '../../services/app.store';

@Component({
  selector: 'app-about-true-view',
  templateUrl: './about-true-view.component.html',
  styleUrls: ['./about-true-view.component.scss'],
  standalone: false,
})
export class AboutTrueViewComponent {
  translationLoadedForTheFirstTime = inject(TvLoginStore).translationLoadedForTheFirstTime;
  protected readonly LABELS = LABELS;
  modalRef: BsModalRef;

  constructor(private modalService: BsModalService) {}

  openModalAbout(template) {
    this.modalRef = this.modalService.show(template, {
      backdrop: true,
      class: 'modal-about',
    });
  }
}
